import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './BidEventsCard.css';
import sampleImage from './image/recomended1.jpg';
import { API_BASE_URL } from '../utils';
import dayjs from "dayjs";

export default function BidEventsCard({ events }) {

    const url = `${API_BASE_URL}/master/assets/uploads/`;


    const todayFormatted = dayjs().format("DD MMM, YYYY");
    const hasTodayEvent = events.some(event => event.event_date === todayFormatted);


    const cardData = [
        {
            title: 'Event 1',
            description: 'Lorem ipsum dolor sit amet consectetur.',
            image: sampleImage
        },
        {
            title: 'Event 2',
            description: 'Adipisicing elit, sed do eiusmod tempor.',
            image: sampleImage
        },
        {
            title: 'Event 3',
            description: 'Incididunt ut labore et dolore magna aliqua.',
            image: sampleImage
        }
        // Add more cards as needed
    ];

    return (
        <div className="bid-events-card-container">
            <Swiper
                spaceBetween={20}
                slidesPerView={1}
                modules={[Pagination]} // ✅ use the Navigation module
                pagination={{ clickable: true }} // ✅ Show clickable dots
                breakpoints={{
                    640: { slidesPerView: 1 },
                    768: { slidesPerView: 1 },
                    1024: { slidesPerView: 1 }
                }}
            >
                {!hasTodayEvent && (
                    <SwiperSlide key="no-event-today">
                        <div className="bid-events-card no-event-card">
                            <div className="bid-events-card-img-no">
                                <div className="bid-events-card-content-no">
                                    <h1>No event for today</h1>
                                    <p>Check back later for upcoming events!</p>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                )}

                {events.map((card, index) => (
                    <SwiperSlide key={index}>
                        <div className="bid-events-card">
                            <div className="bid-events-card-img">
                                <img
                                    src={`https://partywitty.com/master/assets/uploads/${card.image}`}
                                    alt={card.name}
                                />
                                <div className="bid-events-card-favorite-overlay"></div>
                                <div className="bid-events-card-content">
                                    <h1>{card.name}</h1>
                                </div>
                                <div className="bid-events-card-date">
                                    Date: {card.event_date} <br />
                                    Time: {card.event_time} - {card.event_end_time}
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}

            </Swiper>
        </div>
    );
}
